<template>
    <div id="subpage">
        <el-col :span="24" class="warp-breadcrum">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>
                    <b>首页</b>
                </el-breadcrumb-item>
                <el-breadcrumb-item to="/doctor/index">我的课程</el-breadcrumb-item>
                <el-breadcrumb-item>{{ videoData.course_name }}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ videoData.title }}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button size="small" class="reback" type="primary" icon="el-icon-refresh-left" @click="back()">返回
            </el-button>
        </el-col>
        <div class="content">
            <div class="col1 flex" v-loading="loading">
                <div class="flex-grow flex bg-w">
                    <!-- <iframe allow="geolocation; microphone; camera; midi; encrypted-media;"
                        :src="'https://view.csslcloud.net/api/view/index?roomid=' + videoData.live_id + '&userid=651D4C12E0EC0F39&autoLogin=true&viewername=' + accessNick"
                        width="100%" height="1000" sandbox="allow-same-origin allow-scripts" :allow="autoplay"
                        scrolling="no" allow-scripts="" allowfullscreen="true" allowusermedia="">
                    </iframe> -->
                    <iframe allow="geolocation; microphone; camera; midi; encrypted-media;"
                        :src="'https://www.yitku.com/yitku/#/course/bjy-live?course_id=' + videoData.course_id + '&video_id=' + videoData.id"
                        width="100%" height="1000" sandbox="allow-same-origin allow-scripts" :allow="autoplay"
                        scrolling="no" allow-scripts="" allowfullscreen="true" allowusermedia="">
                    </iframe>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: true,
            id: 0,
            video_id: 0,
            course_id: 0,
            videoData: [],
            idx: 0,
            currentIdx: 0,
            pack_id: 0,
            ids: 0,
            autoplay: true,
            accessNick: "",
        };
    },
    methods: {

        /**
         * 获取列表
         */
        getDetail() {
            let that = this;
            that.axios
                .post("/getVideoDetail", { id: that.video_id })
                .then((res) => {
                    if (res) {
                        that.videoData = res.data;
                    }
                    that.loading = false;
                });
        },

        back() {
            if (this.pack_id) {
                this.$router.push({
                    path: "/course/details",
                    query: {
                        id: this.id,
                        pack_id: this.pack_id,
                        ids: this.ids
                    },
                });
            } else {
                this.$router.push({
                    path: "/course/details",
                    query: {
                        id: this.id,
                    },
                });
            }
        },
    },
    //进入页面加载
    mounted: function () {
        var that = this;
        var query = that.$route.query;
        if (query.course_id) {
            that.id = query.course_id;
            that.video_id = query.video_id;
            that.getDetail();
        }
        if (query.pack_id) {
            that.pack_id = query.pack_id;
            that.ids = query.ids;
        }
        that.accessNick = sessionStorage.getItem('access-nick');
    },
};
</script>
<style>
.upview {
    font-size: 12px;
    color: #969696;
}

.el-message-box__wrapper {
    z-index: 99999 !important;
}

.flex-grow {
    flex-grow: 1;
}

.flex-shrink-0 {
    flex-shrink: 0;
}

.inline-block {
    display: inline-block;
}

.bg-2A2D31 {
    background-color: #2a2d31;
}

.bg-26292C {
    background-color: #26292c;
}

.txt-888 {
    color: #888;
}

.course-years {
    height: 42px;
    border: 1px solid #3b3b3b;
    color: #888;
}

.video-list {
    align-items: center;
    border-bottom: 1px solid #37393c;
    padding: 15px 0;
    line-height: 24px;
}

.video-list:hover {
    color: #3078ff;
}

.txt-3078FF {
    color: #3078ff;
}

*::-webkit-scrollbar {
    display: none;
}

.bg1 {
    background-image: url("../../../public/images/bg/3.png");
    background-size: cover;
}

.w28 {
    width: 24px;
}

.w14 {
    width: 14px;
}

.w161 {
    width: 125px;
}

.h10 {
    height: 10px;
}

.h55 {
    height: 55px;
    align-items: center;
}

.h400 {
    height: 400px;
}

.text-white {
    color: #ffffff !important;
}

.border-b-0 {
    border-bottom: none;
}

.overflow-y-scroll {
    overflow-y: scroll;
}
</style>